/* eslint-disable */
export default {
  allCalls: 'Todas las llamadas',
  Unknown: 'Desconocido',
  Multiple: 'Múltiple',
} as const;

// @key: @#@"allCalls"@#@ @source: @#@"All calls"@#@
// @key: @#@"Unknown"@#@ @source: @#@"Unknown"@#@
// @key: @#@"Multiple"@#@ @source: @#@"Multiple"@#@
